import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { previewPages } from '../data/offer';
interface PreviewLightboxProps {
  index: number;
  direction: number;
  onNavigate: (step: number) => void;
  onClose: () => void;
}
export function PreviewLightbox({
  index,
  direction,
  onNavigate,
  onClose
}: PreviewLightboxProps) {
  const reduceMotion = useReducedMotion();
  const closeRef = useRef<HTMLButtonElement>(null);
  const offset = reduceMotion ? 0 : 60;
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'ArrowRight') onNavigate(1);
      if (event.key === 'ArrowLeft') onNavigate(-1);
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose, onNavigate]);
  return <motion.div role="dialog" aria-modal="true" aria-label="Vista ampliada de la página del kit" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.2,
    ease: [0.23, 1, 0.32, 1]
  }} className="fixed inset-0 z-[60] flex flex-col bg-canvas/95 backdrop-blur-sm" onClick={onClose} data-id="element-117" data-mp="1dzueodepis3e">
      <div className="flex items-center justify-between px-4 py-3 sm:px-6" data-id="element-118" data-mp="v92ushx3fjar">
        <p className="text-sm font-medium text-foreground-subtle" aria-live="polite" data-id="element-119" data-mp="vb7b5zc6iarx">
          {index + 1} / {previewPages.length}
        </p>
        <button ref={closeRef} type="button" onClick={onClose} aria-label="Cerrar vista ampliada" className="grid h-11 w-11 place-items-center rounded-full border border-foreground/20 bg-surface text-foreground transition-colors duration-150 ease-out hover:bg-foreground hover:text-canvas" data-id="element-120" data-mp="lbggnxnmbvru">
          <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-121" data-mp="dz8r3dfy528l" />
        </button>
      </div>
      <div className="relative flex-1 overflow-hidden" onClick={event => event.stopPropagation()} data-id="element-122" data-mp="ipyy0v40td5e">
        <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-123" data-mp="41kvymefhspw">
          <motion.img key={index} src={previewPages[index].src} alt={previewPages[index].alt} width="792" height="980" decoding="async" draggable={false} initial={{
          opacity: 0,
          x: direction * offset
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: direction * -offset
        }} transition={{
          duration: 0.24,
          ease: [0.23, 1, 0.32, 1]
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.25} onDragEnd={(_, info) => {
          if (info.offset.x < -60) onNavigate(1);else if (info.offset.x > 60) onNavigate(-1);
        }} className="absolute inset-0 m-auto h-full w-full cursor-grab touch-pan-y object-contain px-2 pb-2 active:cursor-grabbing sm:px-6" data-id="element-124" data-mp="3zhvt9jkaj7g" />
        </AnimatePresence>
      </div>
      <p className="pb-5 pt-2 text-center text-xs text-foreground-subtle" data-id="element-125" data-mp="1pjd6p15owi3q">
        Deslizá para ver la siguiente página
      </p>
    </motion.div>;
}